import { render, staticRenderFns } from "./SalesRecapNew_Invoices.vue?vue&type=template&id=c20bbbe0&"
import script from "./SalesRecapNew_Invoices.vue?vue&type=script&lang=js&"
export * from "./SalesRecapNew_Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports